import { Tag, TagProps, Tooltip } from 'antd';
import { FC, memo } from 'react';
import { CheckCircleFill, RecordCircle, XCircleFill } from 'react-bootstrap-icons';

import { CircleSpinnerIcon } from '@/common/components';

import { PagesCriticalCssGenerationStatus } from '@/modules/Pages';

interface Props {
  withText?: boolean;
  status: PagesCriticalCssGenerationStatus;
}

interface StatusTagProps extends Pick<TagProps, 'color' | 'icon'> {
  label: string;
}

const statusTag: Record<PagesCriticalCssGenerationStatus, StatusTagProps> = {
  [PagesCriticalCssGenerationStatus.NotGenerated]: {
    label: 'Не згенеровано',
    color: 'default',
    icon: null,
  },
  [PagesCriticalCssGenerationStatus.Queued]: {
    label: 'У черзі',
    color: 'gold',
    icon: <RecordCircle size={14} />,
  },
  [PagesCriticalCssGenerationStatus.Generating]: {
    label: 'Генерується',
    color: 'processing',
    icon: <CircleSpinnerIcon/>,
  },
  [PagesCriticalCssGenerationStatus.Generated]: {
    label: 'Згенеровано',
    color: 'success',
    icon: <CheckCircleFill size={14} />,
  },
  [PagesCriticalCssGenerationStatus.GenerationFailed]: {
    label: 'Помилка генерації',
    color: 'error',
    icon: <XCircleFill size={14} />,
  },
};

export const PagesCriticalCssStatusTag: FC<Props> = memo(({ status, withText = true }) => {
  const { label, color, icon } = statusTag[status];

  if (!withText) {
    return icon;
  }

  return (
    <Tooltip title={label}>
      <Tag color={color} icon={icon}>{label}</Tag>
    </Tooltip>
  );
});
